exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-07f27e3a]{padding:.2rem .15rem;overflow-x:hidden;word-break:break-all;white-space:pre-line!important}.title[data-v-07f27e3a]{font-size:.4rem;text-align:center}.content[data-v-07f27e3a]{font-size:.2rem;margin-top:.2rem;line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07f27e3a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/rich-privacypolicy/index.vue
// module id = 359
// module chunks = 1